import { render, staticRenderFns } from "./NsHeaderTop.vue?vue&type=template&id=70807986&scoped=true"
import script from "./NsHeaderTop.vue?vue&type=script&lang=js"
export * from "./NsHeaderTop.vue?vue&type=script&lang=js"
import style0 from "./NsHeaderTop.vue?vue&type=style&index=0&id=70807986&prod&lang=scss"
import style1 from "./NsHeaderTop.vue?vue&type=style&index=1&id=70807986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70807986",
  null
  
)

export default component.exports